import React from "react";
import {
  IconButton,
  styled,
  Dialog,
  DialogProps,
  Paper,
  PaperProps,
} from "@mui/material";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import { clinicScrollableStyle } from "fe-common/ui/commonStyles";

//region [[ Styles ]]
const DraggableArea = styled("div")({
  cursor: "move",
  position: "absolute",
  left: 0,
  top: 0,
  height: 40,
  width: "100%",
  zIndex: 1000,
});

const ClinicDialogView = styled("div")({
  padding: "28px 40px",
  "& .MuiDialogContent-root": { padding: "2px 0" },
  "& .MuiDialogActions-root": {
    padding: "14px 0 0 0",
    justifyContent: "space-between",
  },
  ...clinicScrollableStyle,
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: 10,
  right: 10,
  background: "white",
  zIndex: 1001,
  "&:dir(rtl)": {
    right: "unset",
    left: 10,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicDialogProps extends DialogProps {
  onClose: () => void;
  closeButton: boolean;
  rtlDisplay?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
const DraggablePaper = (props: PaperProps) => {
  return (
    <Draggable
      handle="#draggable-dialog-area"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

export const ClinicDialog = ({
  closeButton,
  onClose,
  open,
  maxWidth,
  rtlDisplay,
  scroll,
  style,
  ...props
}: ClinicDialogProps) => {
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      onClose={() => onClose()}
      dir={rtlDisplay ? "rtl" : ""}
      scroll={scroll}
      style={style}
      PaperComponent={DraggablePaper}
      PaperProps={props.PaperProps}
    >
      <DraggableArea id="draggable-dialog-area" />
      {closeButton && (
        <CloseButton onClick={() => onClose()}>
          <CloseIcon />
        </CloseButton>
      )}
      <ClinicDialogView>{props.children}</ClinicDialogView>
    </Dialog>
  );
};
